/** Layout of the keyword drawer (concept §10.4), shared by the drawer and the result page. */

export const TOPIC_DRAWER_WIDTH = 360;
/** Wide enough to show the drawer beside the result column; below it, it overlays the results. */
export const TOPIC_DRAWER_PUSH_QUERY = '(min-width:1100px)';
/** Height of the fixed app bar on sm and up (matches the main content offset in App.tsx). */
export const APP_BAR_HEIGHT = 80;
